module.exports = __webpack_public_path__ + "img/design-library.beaad746.jpg";